const config = {
   baseURL: '',
   headers: {}
}

function call(method, url, data = null) {
   return new Promise(function (resolve, reject) {
      url = config.baseURL + url
      var xhr = new XMLHttpRequest()
      xhr.open(method, url)
      
      Object.keys(config.headers).map( key => {
         xhr.setRequestHeader(key, config.headers[key])
         return true
      })

      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");


      xhr.onload = function () {
         if (this.status >= 200 && this.status < 300) {

            let type = xhr.getResponseHeader("Content-Type")
            let response = null           
            if(type.indexOf("json") !== -1){
               try {
                  response = JSON.parse(xhr.response)
               } catch(ex) {
                  response = xhr.response
               }
            }

            resolve(response);
         } else {
            reject({
               status: this.status,
               statusText: xhr.statusText
            })
         }
      }

      xhr.onerror = function () {
         reject({
            status: this.status,
            statusText: xhr.statusText
         })
      }

      if(data)
         data = searchParams(data)

      xhr.send( data )
   })
}

function searchParams(params) {
   return Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
   }).join('&');
}

function setHeader( key, value ) {
   config.headers[key] = value
}

function setBaseURL( value ) {
   config.baseURL = value
}

function get( url ) {
   return call('GET', url)
}

function post( url, data ) {
   return call('POST', url, data)
}

export default {
   get,
   post,
   setHeader,
   setBaseURL
}
   
   


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/libraries/Ajax.js